<template>
  <div class="work-page">
    <div class="title">教育经历</div>
    <van-form @submit="onSubmit">

      <van-field
          label="开始时间"
          clickable
          readonly
          name="startTime"
          :value="begin_date |formatshortDate"
          placeholder="请选择"
          :class="{'field-focus': focuseModel === 'f1'}"
          @focus="filedFocus('f1')"
          @blur="filedFocus('')"
          :rules="[{ required: true, message: '' }]"
          @click="showStartDatePicker = true"
          right-icon="arrow"
      />
      <van-popup v-model="showStartDatePicker" round position="bottom" :close-on-popstate="true">
        <van-datetime-picker
            type="year-month"
            v-model="startTime"
            title="选择年月"
            :formatter="formatter"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirmStartDate"
            @cancel="showStartDatePicker = false"
        />
      </van-popup>

      <van-field
          label="结束时间"
          clickable
          readonly
          name="endTime"
          :value="end_date |formatshortDate"
          placeholder="请选择"
          :class="{'field-focus': focuseModel === 'f2'}"
          @focus="filedFocus('f2')"
          @blur="filedFocus('')"
          @click="showEndDatePicker = true"
          :rules="[{ required: true, message: '' }]"
          right-icon="arrow"
      />
      <van-popup v-model="showEndDatePicker" round :close-on-popstate="true" position="bottom">
        <van-datetime-picker
            type="year-month"
            v-model="endTime"
            title="选择年月"
            :formatter="formatter"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirmEndDate"
            @cancel="showEndDatePicker = false"
        />
      </van-popup>

      <van-field
          label="学校"
          v-model="school"
          name="school" maxlength =25
          placeholder="请填写"
          :class="{'field-focus': focuseModel === 'f3'}"
          @focus="filedFocus('f3')"
          @blur="filedFocus('')"
          :rules="[{ required: true, message: '' }]"
      />

      <van-field
          label="专业"
          v-model="major"
          name="major"  maxlength = 25
          :class="{'field-focus': focuseModel === 'f4'}"
          @focus="filedFocus('f4')"
          @blur="filedFocus('')"
          placeholder="专业名称"
          :rules="[{ required: true, message: '' }]"
      />

      <van-field
          label="学历"
          readonly
          clickable
          name="picker"
          v-model="degree.text"
          placeholder="请选择"
          @click="showDegreePicker = true"
          :class="{'field-focus': focuseModel === 'f5'}"
          @focus="filedFocus('f5')"
          @blur="filedFocus('')"
          right-icon="arrow"
          :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="showDegreePicker" round :close-on-popstate="true" position="bottom">
        <van-picker
            show-toolbar
            title="学历"
            :columns="educationTypeList"
            value-key="text"
            @confirm="onConfirmDegree"
            @cancel="showDegreePicker = false"
        />
      </van-popup>
      <div class="submit-content">
<!--        <van-button class="submit-btn"  type="info" native-type="submit"><span>提交</span></van-button>-->
        <p v-if="id" class="submit-btn-cancel" @click="delEducation"><span>删除</span></p>
        <van-button class="submit-btn"  :class="{'disabled':!isAvailable}"  type="info" native-type="submit"><span>保存</span></van-button>
      </div>
    </van-form>


  </div>
</template>

<script>
import { mapState } from "vuex"
import util from "../../../libs/util";
import {Dialog, Toast} from "vant";
import cookies from "@/libs/util.cookies";
import dayjs from "dayjs";
export default {
  name: 'ResumeWork',
  data() {
    return {
      user_id:cookies.get('uid') || '',
      startTime:new Date(),
      begin_date:'',
      end_date:'',
      endTime:new Date(),
      currentDate:'',
      school: '',
      major: '',
      degree:'',
      focuseModel:'',
      minDate: new Date(1990, 0, 1),
      maxDate:new Date(new Date().getFullYear() + 10, 11, 31),
      showStartDatePicker:false,
      showEndDatePicker:false,
      showDegreePicker:false,
      id:'',
    };
  },
  computed: {
    ...mapState('dic', ['educationTypeList']),
    isAvailable (){
      return this.begin_date&& this.end_date&&this.school&&this.major&&this.degree
    }
  },
  created() {
    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link: process.env.VUE_APP_BASEURL +'#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  mounted() {
    if(this.$route.params.info){
      const info = JSON.parse(this.$route.params.info)
      this.begin_date = info.begin_date
      this.end_date = info.end_date
      this.school = info.school_name
      this.major = info.specialities
      this.degree = info.education
      this.id = info.id
      if(this.id){
        util.title('编辑教育经历')
      }
    }
  },
  methods: {
    filedFocus(value){
      this.focuseModel = value
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    delEducation(){
      Dialog.confirm({
        title: '',
        className:'dialog-confirm',
        confirmButtonColor:'#2E5DD2',
        message: '确认删除这份教育经历吗？',
      })
          .then(() => {
            // on confirm
            const params = [this.id]
            this.$api.RESUME_EDU_DEL(params).then(()=>{
              Toast( '删除成功')
              this.$router.go(-1)
            })
          })
          .catch(() => {
            // on cancel
          });
    },
    onSubmit(){
      const param = {
        begin_date:dayjs(this.begin_date).format('YYYY-MM-DD'),
        end_date:dayjs(this.end_date).format('YYYY-MM-DD'),
        school_name:this.school,
        education:this.degree.key,
        specialities:this.major,
        user_id: this.user_id,
        id:this.id,
      }
      this.$api.RESUME_EDU_SAVE(param).then(()=>{

        Toast( '创建成功')
        this.$router.go(-1)
      })

    },
    onConfirmStartDate(date) {
      this.begin_date = date
      this.showStartDatePicker = false;
    },
    onConfirmEndDate(date) {
      this.end_date = date
      this.showEndDatePicker = false;
    },
    onConfirmDegree(value) {
      this.degree = value
      this.showDegreePicker = false;
    },
  },
}
</script>

<style scoped>
.title{
  font-size: 24px;
  font-weight: bold;
  color: #333333;
}
.work-page{
  text-align:left;
  padding-bottom:65px;
}
.work-page .title{
  padding:10px 20px;
  margin:10px 0 0 0;
}

.submit-content{
  display:flex;
  justify-content: space-between;
  position:fixed;
  bottom: 0;
  left:0;
  width:calc(100vw - 40px);
  padding:0 20px 10px 20px;
  background:  linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}
.submit-btn-cancel{
  width:84px;
  flex-shrink: 0;
  margin:0 auto;
  margin-right:15px;
  height:44px;
  border-radius: 22px;
  font-size:16px;
  color:#333;
  font-weight: bold;
  border: 1px solid #EAEDF0;
  background:#ffffff;
}

.submit-btn-cancel span{
  display:block;
  text-align: center;
  line-height:44px;
}
.submit-btn.disabled span{
  opacity:0.5;
}
.submit-btn{
  display:block;
  width:calc(100vw - 40px);
  height:44px;
  margin:0 auto;
  font-weight: bold;
  background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
  border-radius: 22px;
  font-size:16px;
  color:#fff;
}

::v-deep .submit-btn.van-button--disabled{
  opacity:1;
}

::v-deep .submit-btn.van-button--disabled span{
  opacity:0.5;
}

::v-deep .van-cell{
  display:block;
  line-height:28px;
  padding:13px 20px;
  font-size:16px;
  color:#333;
  border-color:#F1F4F6;
}

/* ::v-deep .van-field__error-message{
  display:none;
} */

::v-deep .van-cell__title{
  font-size:12px;
  color:#999;
  padding-bottom:5px;
}

.field-focus::after{
  border-color:#3163E0;
  transform: scaleY(1);
}

::v-deep .field-arrow .van-cell__value{
  position: relative;
  padding-right:20px;
}

::v-deep .field-arrow .van-cell__value::after{
  display:block;
  content:'';
  width:19px;
  height:16px;
  background:url(../../../assets/images/mine/icon-arrow.png);
  background-size:19px 16px;
  position: absolute;
  right:0;
  top:0;
  margin:8px 0;
}

::v-deep .van-picker__confirm{
  color:#3871FF;
}
</style>
